/**
 * @generated SignedSource<<dba4554211950c92b7fad41c09cb36c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsBioModalLazy_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsBioModal_seller">;
  readonly " $fragmentType": "PdpSharedDealerDetailsBioModalLazy_seller";
};
export type PdpSharedDealerDetailsBioModalLazy_seller$key = {
  readonly " $data"?: PdpSharedDealerDetailsBioModalLazy_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsBioModalLazy_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerDetailsBioModalLazy_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsBioModal_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "25e812ab7f981a7d66f81a23e8415151";

export default node;
